import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFitScreen = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-298.67 -348.44 2133.33 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M745 457 413 125 557 -19Q576 -38 576.0 -64.0Q576 -90 557.0 -109.0Q538 -128 512 -128H64Q38 -128 19.0 -109.0Q0 -90 0 -64V384Q0 410 19.0 429.0Q38 448 64.0 448.0Q90 448 109 429L253 285L585 617Q595 627 608.0 627.0Q621 627 631 617L745 503Q755 493 755.0 480.0Q755 467 745 457ZM1536 1344V896Q1536 870 1517.0 851.0Q1498 832 1472.0 832.0Q1446 832 1427 851L1283 995L951 663Q941 653 928.0 653.0Q915 653 905 663L791 777Q781 787 781.0 800.0Q781 813 791 823L1123 1155L979 1299Q960 1318 960.0 1344.0Q960 1370 979.0 1389.0Q998 1408 1024 1408H1472Q1498 1408 1517.0 1389.0Q1536 1370 1536 1344Z"
	})
});
export default SvgFitScreen;
